import React, { Component } from "react";
import { Dropdown, Mentions, Popover, Button, Modal } from "antd";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import LiveScheduleUpdate from './LiveScheduleUpdate/LiveScheduleUpdate.js';
import WorkerContactDetails from './WorkerContactDetails.js'
import blankTour from './utils/live-schedules/blankTour.js';
import blankDayType from './utils/live-schedules/blankDayType.js';
import blankAssignment from './utils/live-schedules/blankAssignment.js';
import ContextMenu from '../../utils/ContextMenu.js';
import groupContextMenu from './utils/live-schedules/context-menu-arrays/group.js';
import * as resourceActions from '../../redux/actions/resourceActions.js';
import AuthLogic from '../../AuthLogic/index.js'


const ADD_TOUR = "Add Tour";
const CHANGE_DAY_TYPE = "Change Day Type";
const ADD_ASSIGNMENT = "Add Assignment";
const ADD_DAYS_OFF_REQUEST = "Add Days Off Request";

class LiveScheduleGroupContext extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contextMenuSelection: '',
      liveScheduleUpdate: false,
      resource: {
        id: this.props.group.id,
        name: this.props.group.title,
        class: this.props.group.class,
      },
      itemDetails: {},
      contactInfoModal: false
    };
  }

  handleGroupContextSelect = async () => {
    this.setState({
      liveScheduleUpdate: true
    });
  };

  closeLiveScheduleUpdate = (liveScheduleUpdateState) => {
    if (liveScheduleUpdateState) {
      console.log(`liveScheduleUpdateState.crudLoading: ${liveScheduleUpdateState.crudLoading}`); // debug
    }

    if (liveScheduleUpdateState) {
      if (
        !liveScheduleUpdateState.crudError
        && !liveScheduleUpdateState.crudLoading
        && !liveScheduleUpdateState.deleteJobElementLoading
        && !liveScheduleUpdateState.deleteEmptyJobLoading
        ) {
          this.setState({
            liveScheduleUpdate: false,
            itemDetails: {} // clear form fields
          });
      }
    }
  }

  loadBlankItem = (key) => {
    const formTitle = key.item.props.children;
    const { startDate } = this.props;
    let blankItem;
    switch (formTitle) {
      case ADD_TOUR:
        blankItem = blankTour(startDate);
        break;
      case CHANGE_DAY_TYPE:
        blankItem = blankDayType(startDate);
        break;
      case ADD_ASSIGNMENT:
        blankItem = blankAssignment(startDate);
        break;
      case ADD_DAYS_OFF_REQUEST:
        blankItem = blankDayType(startDate); // <- James might need to change later
        break;
      default:
        blankItem = null;
    }
    const itemDetails = { ...blankItem };
    itemDetails.source = 'LiveScheduleGroupContext';
    itemDetails.resourceName = this.state.resource.name;
    this.setState({
      itemDetails,
      contextMenuSelection: formTitle
    }, () => {
      this.handleGroupContextSelect()
    });
  };

  handleContactInfo = async () => {
    const { startDate } = this.props;

    let parameters = {
      resourceId: this.state.resource.id,
      startDate: startDate
    };

    await this.props.actions.fetchResourceContactInfo(parameters);

    this.setState({
      contactInfoModal: true
    });
  }

  handleModalCancel = () => {
    this.setState({
      contactInfoModal: false
    });
  }

  render() {
    // console.log('Group Context Item Details: ', this.state.itemDetails);  // debug
    // console.log(this.state.contextMenuSelection);  //
    const group = this.props.group;
    const className = group.empCat === 'S' || group.empCat === 'Staff' ? "staff" : "";
    if (group.class === 'Facility') return (
      <div style={{ fontSize: 12, cursor: 'pointer' }}
        className={className}
      >
        {group.title}
      </div>
    )
    if (this.props.editMode) {
      return (
        <Popover
          title={group.title}
          placement="rightTop"
          content={
            <React.Fragment>
              {AuthLogic.resourceInfo(this.props.user) &&
                <Button
                  style={{ display: 'block', marginBottom: 10 }}
                  onClick={this.handleContactInfo}
                >Contact Information</Button>
              }

              <ContextMenu
                menuTitle={<Mentions style={{ border: 'none', fontWeight: 'bold' }} readOnly placeholder={'Resource Menu'} />}
                user={this.props.user}
                menuArray={Object.values(groupContextMenu)}
                handleSelection={this.loadBlankItem}
              />

              <Modal
                zIndex={2000}
                title="Contact Information"
                open={this.state.contactInfoModal}
                onCancel={this.handleModalCancel} // the x in top right corner
                footer={[]}
              >
                <WorkerContactDetails
                  resource={this.props.resourceContactInfo[0]}
                  user={this.props.user}
                />
              </Modal>
            </React.Fragment>
          }
          trigger={!this.state.liveScheduleUpdate ? 'click' : ''}
        >
          <div style={{ fontSize: 12, cursor: 'pointer' }}
            className={className}
          >
            {group.title}

            {this.state.liveScheduleUpdate &&
              <LiveScheduleUpdate
                updateType={'groupContextMenu'}
                contextMenuSelection={this.state.contextMenuSelection}
                resource={this.state.resource}
                startDate={this.props.startDate}
                itemDetails={this.state.itemDetails}
                updateOptimisticLiveSchedule={this.props.updateOptimisticLiveSchedule}
                closeLiveScheduleUpdate={this.closeLiveScheduleUpdate}
              />
            }
          </div>
        </Popover>
      );
    } else {
      return (
        <Popover
          title={group.title}
          placement="rightTop"
          content={
            <React.Fragment>
              {AuthLogic.resourceInfo(this.props.user) &&
                <Button
                  className="contact-info-button"
                  style={{ display: 'block', marginBottom: 10 }}
                  onClick={this.handleContactInfo}
                >Contact Information</Button>
              }
              <Modal
                zIndex={2000}
                title="Contact Information"
                open={this.state.contactInfoModal}
                onCancel={this.handleModalCancel} // the x in top right corner
                footer={[]}
              >
                <WorkerContactDetails
                  resource={this.props.resourceContactInfo[0]}
                  user={this.props.user}
                />
              </Modal>
            </React.Fragment>
          }
          trigger={!this.state.liveScheduleUpdate ? 'click' : ''}
        >
          <div style={{ fontSize: 12, cursor: 'pointer' }}
            className={className}
          >
            {group.title}
          </div>
        </Popover>
      );
    }
  }
}


LiveScheduleGroupContext.propTypes = {
  editMode: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    editMode: state.editMode.status,
    user: state.user,
    resourceContactInfo: state.resourceContactInfo.data
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchResourceContactInfo: bindActionCreators(
        resourceActions.fetchResourceContactInfo,
        dispatch
      )
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LiveScheduleGroupContext);

